import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  let isAuth = window.abp.session.userId != null;
  let needsAuthorization = to.meta.authorized == null;
  if (needsAuthorization && !isAuth) {
    next({
      name: 'login',
      query: { returnUrl: to.fullPath }
    })
    next()
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#root')



// WEBPACK FOOTER //
// ./scripts/main.js